<template>
  <div class="editor-container">
    <csml-monaco-editor
      v-model="csmlContent"
      class="csml-editor"
      @change="updateContent"
      @editorDidMount="onEditorDidMount"
      @save="onSave"
    />
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import { loadCode, saveCode } from '../session.js';

export default {
  data () {
    return {
      // Fora do MA, volta com o último código editado neste navegador.
      // Dentro do iframe do MA o código vem do MA (editorContext).
      csmlContent: window.parent === window ? loadCode() : ''
    }
  },
  methods: {
    updateContent(newContent) {
      this.csmlContent = newContent;
      if (window.parent === window) {
        saveCode(newContent);
      }
      EventBus.$emit('update:csmlContent', newContent);
      // Comunica a atualização para o MA (iframe) via postMessage
      window.parent.postMessage(
        "chatwoot-csml-editor:update" + newContent,
        "*"
      );
    },
    onEditorDidMount(editor) {
      this.$emit('editor-ready', editor);
    },
    onSave() {
      EventBus.$emit('menu-action', 'arquivo-salvar');
    },
    onWindowMessage(event) {
      if (typeof event.data !== 'string') {
        return;
      }
      let eventData;
      try {
        eventData = JSON.parse(event.data);
      } catch (e) {
        return;
      }
      if (eventData.event === "editorContext") {
        this.updateContent(eventData.data);
      }
    },
  },
  mounted() {
    window.addEventListener("message", this.onWindowMessage);
    if (this.csmlContent) {
      EventBus.$emit('update:csmlContent', this.csmlContent);
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onWindowMessage);
  },
  watch: {
    csmlContent(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateContent(newVal);
      }
    }
  },
}
</script>

<style scoped>
.csml-editor {
  height: 100%;
  width: 100%;
}

.editor-container {
  flex: 1;
  min-height: 0; /* Impede que o container encolha abaixo do conteúdo */
}
</style>
